<div>

  @if (dadosResumo) {
    <div>
      <!-- 1ª PARTE - DADOS -->
      <div class="row">
        <div class="col-6 col-md-3 col-lg-2 mb-4">
          <span class="titulo-api">Número do pedido</span>
          <p class="dado-api">{{dadosResumo.idPedido}}</p>
        </div>
        <div class="col-6 col-md-3 col-lg-2 mb-4">
          <span class="titulo-api">Emissão</span>
          <p class="dado-api">{{dadosResumo.dataEmissao | appDate: 'dd/MM/yyyy HH:mm'}}</p>
        </div>
        <div class="col-6 col-md-3 col-lg-2 mb-4">
          <span class="titulo-api">Data pagamento</span>
          @if (dadosResumo.dataPagamento) {
            <p class="dado-api">{{dadosResumo.dataPagamento | appDate: 'dd/MM/yyyy'}}</p>
          }
          @if (!dadosResumo.dataPagamento) {
            <p class="dado-api">Sem data</p>
          }
        </div>
        <div class="col-6 col-md-3 col-lg-2 mb-4">
          <span class="titulo-api">Data Entrega</span>
          <p class="dado-api">{{dadosResumo.dataEntrega | appDate: 'dd/MM/yyyy'}}</p>
        </div>
        <div class="col-6 col-md-6 col-lg-4 mb-4">
          <span class="titulo-api">Tipo</span>
          <p class="dado-api">{{dadosResumo.tipoPedido | camelCase}}</p>
        </div>
        <!-- 2ª PARTE -->
        <div class="col-6 col-md-3 col-lg-2 mb-4">
          <span class="titulo-api">Contato</span>
          <p class="dado-api">{{dadosResumo.nomeContato | camelCase}}</p>
        </div>
        <div class="col-6 col-md-3 col-lg-2 mb-4">
          <span class="titulo-api">Sit. Financeiro</span>
          <p class="dado-api">{{dadosResumo.situacaoFinanceiro | camelCase}}</p>
        </div>
        <div class="col-6 col-md-3 col-lg-2 mb-4">
          <span class="titulo-api">Sit. Operacional</span>
          <p class="dado-api">{{dadosResumo.situacaoOperacional}}</p>
        </div>
        <div class="col-6 col-md-6 col-lg-6 mb-4">
          <span class="titulo-api">Ordem dos envelopes/recibos</span>
          <p class="dado-api">{{dadosResumo.ordemEnvelopesRecibos | camelCase}}</p>
        </div>
        <!-- 3ª PARTE -->
        <div class="col-6 col-md-3 col-lg-2 mb-4">
          <span class="titulo-api">Valor Itens</span>
          <p class="dado-api">{{dadosResumo.valorItens}}</p>
        </div>
        <div class="col-6 col-md-3 col-lg-2 mb-4">
          <span class="titulo-api">Valor Taxa</span>
          <p class="dado-api">{{dadosResumo.valorTaxas}}</p>
        </div>
        <div class="col-6 col-md-3 col-lg-2 mb-4">
          <span class="titulo-api">Valor Pedido</span>
          <p class="dado-api">{{dadosResumo.valorTotal}}</p>
        </div>
        @if (pedidoPapel === false) {
          <div class="col-6 col-sm-4 col-md-4 col-lg-3 col-xl-2 mb-4">
            <span class="titulo-api">Gerar arquivo folha txt</span>
            <p class="dado-api text-center">
              <button id="btnGerarFolhaTxt" (click)="gerarArquivoFolha(dadosResumo.idPedido)" class="btn-icon">
                <i class="fa fa-download c-primary icone-menor" aria-hidden="true"></i>
              </button>
            </p>
          </div>
        }
        @if (pedidoPapel === false) {
          <div class="col-6 col-md-12">
            <span class="titulo-api">Período de utilização</span>
            <p class="dado-api">{{dadosResumo.dataInicioUtilizacao | appDate: 'dd/MM/yyyy'}} | {{dadosResumo.dataFimUtilizacao | appDate: 'dd/MM/yyyy'}}</p>
          </div>
        }
      </div>
      <!-- COMPOSIÇÃO DA TAXA -->
      <div class="row border-top pt-3 mt-3">
        <div class="col-12">
          <span class="titulo-api">Composição da taxa</span>
          @for (composicao of dadosResumo.listaComposicaoTaxas; track composicao) {
            <p class="dado-api">{{composicao}}</p>
          }
        </div>
      </div>
    </div>
  }

  @if (dadosResumo === null) {
    <div>
      <div class="text-center">
        <output class="spinner-border c-primary">
          <span class="visually-hidden">Consultando dados do Resumo do pedido ...</span>
        </output>
      </div>
      <p class="legenda-spinner">Consultando dados do Resumo do pedido ...</p>
    </div>
  }

  @if (dadosResumo === false) {
    <div class="text-center">
      <img src="/assets/img/erro.png" alt="representando erro na consulta do resumo dos pedidos" width="200px">
      <p class="legenda-erro">Ocorreu um erro na consulta do resumo. Verifique se o número do pedido está correto.</p>
    </div>
  }

</div>
